export default __webpack_public_path__ + "static/media/urbain.15278682.svg";